import MfSelfService from 'ui/mfs/MfSelfService';

const CycleHighlights = () => <MfSelfService document="destaques_do_ciclo" />;

export default CycleHighlights;
